// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
import { Deserializable } from './deserializable.model';

export class SubjectCommunication {
  public subject_com_type_id?: number | 0;
  public doc_id?: number;
  public attached_file_name?: string;
  public change_dates?: string;
  public attached_file_names?: string;
  public attached_job_file_names?: string;
  public additional_message?: string;
  public brand_type_id?: number;
  public brand_id?: number;
  public all_attached_file_names?: string;

  public send_to_invoice?: number;
  public send_to_report?: number;
  public send_to_logins?: number;
  public send_to_primary?: number;
  public allAttachments?: any;
  allRecipients?: any;
  allAttachedFiles?: any;

  public brand_report_id?: number;
  public brand_invoice_id?: number;

  public job_type_name?: string;
  public job_type_location_name?: string;
public brand_report_user_id?: number;

email_message_subject?: string;
email_message_recipeints?: any;

  job_id?: number;
  subject_id?: number;
  message_subject?: string;
  recipient_name?: string;
  recipient_type_name?: string;
  recipient_email_address?: string;
  email_template_HTML: any;
  subject_number?: number;

  assigned_to_agents?: any;

  created_by?: number;
created_date?: string;
// updated_by?: number;
// updated_date?: string;

subject_communication_history_id?: any; // created a new table subject_communication_history to log communications in system

email_template_primary_HTML?;
  time_service_text?: string;
  service_paragraph_rendered?: any;
  

  email_template_primary_HTML_rendered?: string;
  email_subject_primary_rendered?: string;
  note_template_HTML_rendered?: string;
  email_template_private_HTML_rendered?: string;
  email_subject_private_rendered?: string;
  note_template_private_HTML_rendered?: string;
  is_privacy_emails?: string;
  is_privacy_notes?: string;
  is_privacy_no_docs?: string;
  is_privacy_no_emails?: string;
  is_privacy_no_notes?: string;
  created_note_id?: string;
  created_file_id?: string;



  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SubjectCommunication {
    Object.assign(this, input);

    return this;
  }
}

// Set the Stats
